import { FAQ, Panel, PanelState, theme, useMediaMin } from '@foradevelopment/fora-ui';
import {
  EmploymentBoardDecisionLockViewModel,
  EmploymentViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

import { useTypedTranslation } from '../../../i18n/i18n';
import { EmploymentConfirmationDetailsSettingsOld } from '../../../components';
import { EditEmploymentForm } from '../../components/EditEmploymentForm';
import { useAppSelector } from '../../../redux/hooks';

export const EditEmploymentPanel = ({
  employment,
  boardDecisionLock,
  panelState,
  goToNextPanel,
}: {
  employment: EmploymentViewModel;
  boardDecisionLock: EmploymentBoardDecisionLockViewModel | null;
  panelState: PanelState;
  goToNextPanel: (confirmationDetailsSettings: EmploymentConfirmationDetailsSettingsOld) => void;
}) => {
  const { t } = useTypedTranslation();
  const faqs = useAppSelector(state => state.content.content.faqListUpdateEmployment);
  const isDesktop = useMediaMin(theme.breakpoint.lg);

  return (
    <Panel {...panelState} name="edit-employment-panel">
      <Panel.Header>{t('crumbs.editEmployee')}</Panel.Header>
      <Panel.Body>
        <Panel.MainSection>
          <EditEmploymentForm
            employment={employment}
            goToNextPanel={goToNextPanel}
            boardDecisionLock={boardDecisionLock}
          />
        </Panel.MainSection>
        <Panel.AsideSection>
          {faqs.length > 0 && isDesktop && (
            <FAQ testId="test-edit-employment-faq" layout="side" questionAnswers={faqs} />
          )}
        </Panel.AsideSection>
        {faqs.length > 0 && !isDesktop && (
          <FAQ testId="test-edit-employment-faq" layout="modal" questionAnswers={faqs} />
        )}
      </Panel.Body>
    </Panel>
  );
};
